import { getUserAccountProfile, useAppSelector } from 'store';

export const useUserAccountProfile = () =>
  useAppSelector(getUserAccountProfile);
